<template>
  <cHeader></cHeader>
  <div class="home-container">

    <div class="home-box">
      <div class="hoem-title">
        <p class="row1">{{ t('home_title') }}</p>
        <p class="d-flex align-center row2">
          {{t('speaking_test')}}
          <img class="ml-8" :src="require('@/assets/home-arrow.png')" height="12" >
        </p>
      </div>
      <div class="code-box">
        <p class="title">감독관 접속코드</p>
        <p class="comment">Supervisor access code</p>

        <div class="input-wrap">
          <input v-model="mngrCd" type="text" :placeholder="t('code_msg')" maxlength="8" @keydown.enter="go_manager()">
          <img :src="require('@/assets/ico-arrow-right-bg.png')" width="52" height="52"
          @click="go_manager()">
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { strUtil } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useBaseStore } from '@/stores/base'
import { usePopupStore } from '@/stores/popup'
import cHeader from '@/components/cHeader.vue';

const baseStore = useBaseStore()
const popupStore = usePopupStore()
const { t, locale } = useI18n();

const mngrCd = ref("")
const go_manager = async () => {
  try{
    if(!strUtil.isEmpty(mngrCd.value) && strUtil.validateStringLength(mngrCd.value, 8, 8)){

      const { default: ApiMngrLogin } = await import('@/api/mngrLogin');
      const params = { loginCode: mngrCd.value }
      const mngrLogin = await ApiMngrLogin(params)

      baseStore.setManagerCd(mngrCd.value)
      baseStore.setManagerInfo(mngrLogin.examOpr)
      baseStore.setQrInfo(mngrLogin.qrCode)

      if(mngrLogin.result){
        baseStore.goRouter('/testmanager')  
      } else {
        popupStore.openDialog({ title: t('login_false_title'), msg: t('login_false_msg') });
      }
    }else{
      popupStore.openDialog({ title: t('login_title'), msg: t('login_msg') });
      return false  
    }
  }catch(error){
    console.log("시험관 로그인 에러.")
  }
}

const loadExamInfo = () => {

}


</script>

<style lang="scss" scoped>
@import '@/sass/app.scss';

.home-container {
  display: flex;
  align-items: center;
  justify-content: center; /* 수평 중앙 정렬 */
  width: 100%;
  height: calc(100vh - 73px);
  background-color: #F9F8F5;
  background-image: url('@/assets/bg-main-left_top.png'), url('@/assets/bg-main_bottom.png');
  background-size: 194px 147px, 100vw auto;
  background-position: right top, center bottom; /* 첫 번째 이미지는 우측 상단에, 두 번째 이미지는 하단 중앙에 위치 */
  background-repeat: no-repeat, no-repeat;
}

.home-box {
  width: 656px;
  height: 392px;
  margin: 0px auto 73px;
  background-image: url('@/assets/king-sejong.png');
  background-size: auto 357px;
  background-position: 0 0;
  background-repeat: no-repeat;
}

.hoem-title {
  margin: 17px 0 0 237px;
}

.row1 {
  font-size: 40px;
  letter-spacing: -1.2px;
  line-height: 58px;
  display: inline-block;
  font-family: '세종학당 제목체', sans-serif;
  color: #111;
  word-break: break-all;
  /* 단어가 너무 길면 중간에 끊어줌 */
  white-space: normal;
  /* 공백이 여러 개여도 한 칸으로 간주 */
}

.row2 {
  font-size: 40px;
  letter-spacing: -1.2px;
  line-height: 58px;
  display: inline-block;
  font-family: '세종학당 제목체', sans-serif;
  color: #111;
  background-image: url('@/assets/wave.png');
  background-size: auto 33px;
  background-position: right 98px top 12px;
  background-repeat: no-repeat;
}

.code-box {
  position: relative;
  width: 612px;
  height: 212px;
  margin: 47px 0 0 44px;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.06);
  border-radius: 24px;
  background-color: #fff;
  border: solid 1px #000;
  padding: 40px 32px;

  p.title {
    font-size: 24px;
    letter-spacing: -0.4px;
    line-height: 24px;
    font-family: 'Pretendard GOV';
    color: #111;
    margin-bottom: 10px;

  }

  p.comment {
    font-size: 14px;
    letter-spacing: -0.4px;
    line-height: 14px;
    font-family: 'Pretendard GOV';
    color: #acacac;
    margin-bottom: 32px;

  }
}

.input-wrap {
  display: flex;
  align-items: center;
  width: 100%;

  input {
    width: calc(100% - 60px);
    height: 52px;
    margin-right: 8px;
    border-radius: 12px;
    background-color: #f7f7f7;
    padding: 0px 20px;
    font-size: 24px;
    letter-spacing: 3px;
    line-height: 52px;
    font-weight: bold;
  }
}
</style>